import { EpicContextService } from '../services/EpicContextService/epic.context';
import { Models } from '../models/models';
export interface IGlobalPudge {
    context: Models.IKeyValue<any>[];
    functions: EpicContextService.IEpicFunctions;
    getParam: (...args: any[]) => any;
}
export default {
    install(vue: any, options: any) {
        EpicContextService.init();
        vue.mixin({
            data: function () {
                return {
                    globalPudge: {
                        context: EpicContextService.instance(),
                        functions: (window as any).epicFunctions,
                        getParam: function (key: string) {
                            const result = this.context.find((v: Models.IKeyValue<any>) => {
                                return v.key === key;
                            });
                            return result ? result.value : null;
                        }
                    }
                };
            }
        });
        vue.prototype.$test = {
            context: EpicContextService.instance(),
            functions: (window as any).epicFunctions,
            getParam: function (key: string) {
                const result = this.context.find((v: Models.IKeyValue<any>) => {
                    return v.key === key;
                });
                return result ? result.value : null;
            }
        };
    }
};

